// Initialize polyfills before any dependencies are loaded
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as StoreProvider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import Raygun from 'raygun4js';
import { ConnectedRouter } from 'connected-react-router';
import configureStore, { history } from './store';
import App from './App';
import {
  ThemeProvider,
  ThemeOverrides,
} from './components';
import userManager from './utils/userManager';

// process.env.NODE_ENV is injected at build time by webpack.Define plugin
// Thus, the if statement will look like if ('Production' !== 'Local')
// which will then be optimized by the minification process
// (so the wrapping if statement will disappear)
if (process.env.NODE_ENV !== 'local') {
  Raygun('enableCrashReporting', true);
  Raygun('apiKey', '5SneNeE4m7QlE993NjUpQ');
}

if (module.hot) {
  // Enable Webpack hot module replacement for components
  module.hot.accept('./components');
}

ReactDOM.render(
  <StoreProvider store={configureStore()}>
    <OidcProvider store={configureStore()} userManager={userManager}>
      <ConnectedRouter history={history}>
        <ThemeProvider>
          <ThemeOverrides>
            <App />
          </ThemeOverrides>
        </ThemeProvider>
      </ConnectedRouter>
    </OidcProvider>
  </StoreProvider>,
  document.getElementById('root'),
);
